export enum DeeplinkKey {
	NOTE_ID = 'noteId',
	NOTE_MESSAGE_ID = 'noteMessageId',
}
